<template>
  <el-dialog title="手动录入订单" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="110px"
      style="margin: 0 30px"
    >
      <template>
        <el-form-item label="产品名称" prop="product_id">
          <el-select
            v-model="temp.product_id"
            filterable
            placeholder="请选择"
            style="width: 100%"
            @change="changeProduct"
          >
            <el-option
              v-for="item in product_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目">
          <el-input v-model="project_name" readonly />
        </el-form-item>
        <el-form-item label="场次">
          <el-input v-model="interval_time" readonly />
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="trip_type" readonly />
        </el-form-item>
        <el-form-item label="所属平台">
          <el-input v-model="platform" readonly />
        </el-form-item>
        <el-form-item label="数量" prop="user_num">
          <el-input v-model="temp.user_num" />
        </el-form-item>
        <el-form-item label="总金额" prop="price">
          <el-input v-model="temp.price" />
        </el-form-item>

        <el-form-item label="出发日期" prop="use_date">
          <el-date-picker
            v-model="temp.use_date"
            type="date"
            placeholder="选择用户下单的出发日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="联系人姓名" prop="contact_name">
          <el-input v-model="temp.contact_name" />
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contact_mobile">
          <el-input type="mobile" v-model="temp.contact_mobile" maxlength="11" />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { manualAddOrder } from '@/api/orders'
import { getList as getProductsList } from '@/api/products'

const rule = [{ required: true, message: '必填项不能为空' }]
export default {
  name: 'AddOrder',
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      temp: {
        product_id: '',
        user_num: '',
        price: '',
        use_date: '',
        contact_name: '',
        contact_mobile: ''
      },
      project_name: '',
      interval_time: '',
      trip_type: '',
      platform: '',
      rules: {
        product_id: rule,
        user_num: rule,
        price: rule,
        use_date: rule,
        contact_name: rule,
        contact_mobile: rule
      },

      product_options: []
    }
  },

  created() {},
  methods: {
    handleAddOrder() {
      getProductsList({ size: 1000, is_manual_order: 1, shelf_status: 1 }).then((res) => {
        this.product_options = res.data.results
      })
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    changeProduct(id) {
      const product = this.product_options.find((item) => item.id === id)
      this.temp.product_id = id
      this.project_name = product.project.name
      this.interval_time = product.interval_time
      this.trip_type = product.trip_type === 1 ? '拼团' : '包团'
      this.platform = this.$platform[product.platform]
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (!/^(1[3-9]\d{9})$/.test(this.temp.contact_mobile)) {
            return this.$message.error('请输入正确的手机号!')
          }
          const d = JSON.parse(JSON.stringify(this.temp))
          manualAddOrder(d).then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.temp = {
              product_id: '',
              user_num: '',
              price: '',
              use_date: '',
              contact_name: '',
              contact_mobile: ''
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.item-p {
  margin: 0;
  /* height: 1px; */
}
</style>
